<template>
  <div class="parking-list">
    <el-card>
      <div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
        <span>停车场列表</span>
        <el-button type="primary" size="small" @click="handleAdd">新增停车场</el-button>
      </div>

      <el-table :data="tableData" border stripe>
        <el-table-column prop="name" label="停车场名称" width="200"></el-table-column>
        <el-table-column prop="address" label="地址" min-width="250"></el-table-column>
        <el-table-column prop="totalSpaces" label="总车位" width="100" align="center"></el-table-column>
        <el-table-column prop="availableSpaces" label="可用车位" width="100" align="center"></el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'" size="small">
              {{ scope.row.status === 'active' ? '运营中' : '已停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="停车场名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入停车场名称"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="总车位数" prop="totalSpaces">
          <el-input-number v-model="form.totalSpaces" :min="1" style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { parkingApi } from '@/api'

export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      form: {
        name: '',
        address: '',
        totalSpaces: 0
      },
      rules: {
        name: [{ required: true, message: '请输入停车场名称', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        totalSpaces: [{ required: true, message: '请输入总车位数', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.form.id ? '编辑停车场' : '新增停车场'
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        const { data } = await parkingApi.getList()
        this.tableData = data
      } catch (error) {
        this.$message.error('加载失败')
      }
    },
    handleAdd() {
      this.form = { name: '', address: '', totalSpaces: 0 }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.form = { ...row }
      this.dialogVisible = true
    },
    async handleDelete(id) {
      try {
        await this.$confirm('确定删除该停车场?', '提示', { type: 'warning' })
        await parkingApi.delete(id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            if (this.form.id) {
              await parkingApi.update(this.form.id, this.form)
            } else {
              await parkingApi.create(this.form)
            }
            this.$message.success('操作成功')
            this.dialogVisible = false
            this.loadData()
          } catch (error) {
            this.$message.error('操作失败')
          }
        }
      })
    }
  }
}
</script>
